import { render, staticRenderFns } from "./consecutivos.vue?vue&type=template&id=2157f854"
import script from "./consecutivos.vue?vue&type=script&lang=js"
export * from "./consecutivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports